import { render, staticRenderFns } from "./PrecoPraticadoCidade2.vue?vue&type=template&id=24acac80&scoped=true&"
import script from "./PrecoPraticadoCidade2.vue?vue&type=script&lang=js&"
export * from "./PrecoPraticadoCidade2.vue?vue&type=script&lang=js&"
import style0 from "./PrecoPraticadoCidade2.vue?vue&type=style&index=0&id=24acac80&scoped=true&lang=css&"
import style1 from "./PrecoPraticadoCidade2.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acac80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
